import { useLocation, useNavigate } from "react-router-dom";
import { MarketingHeader } from "./MarketingHeader";
import { useMobileMenu } from "@platform/store";

export type Props = {
  // navigation items component
  children: React.ReactNode;
};

export function MarketingHeaderContainer({ children }: Props) {
  const { isOpen: isMobileMenuOpen, open: openMobileMenu, close: closeMobileMenu } = useMobileMenu();
  const navigate = useNavigate();
  const { pathname, hash } = useLocation();

  /**
   * What the mark does. On the homepage it returns to the top rather than
   * fetching the page again, which is what following the link would do; from
   * anywhere else it goes home.
   */
  const handleHomeClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // A held key asks for a new tab or window, which is the browser's to do.
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    closeMobileMenu();
    if (pathname !== "/") {
      navigate("/");
      return;
    }
    // An address naming a section would disagree with the top of the page,
    // and would send a reader back down on a refresh.
    if (hash) navigate("/", { replace: true });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <MarketingHeader
      isMobileMenuOpen={isMobileMenuOpen ?? false}
      openMobileMenu={openMobileMenu}
      closeMobileMenu={closeMobileMenu}
      onHomeClick={handleHomeClick}
    >
      {children}
    </MarketingHeader>
  );
}

export default MarketingHeaderContainer;

